export default {
    buttons: {
        back: "Back",
        next: "Next",
        submit: "Submit"
    }
}